/**
 * All drag and drop item types
 */ export const ItemTypes = {
    /** Draggable/droppable board card */ Card: "card",
    /** Draggable member card */ MemberCard: "memberCard",
    /** Draggable/droppable board column */ Column: "column",
    /** Draggable list item in My Tasks list view */ ListItem: "listItem"
};
/**
 * Drag and drop attribute data-dnd-role values
 */ export const DnDRoleAttribute = {
    /** Card area */ card: "card",
    /** Column area */ column: "column",
    /** Column group area */ columnGroup: "columnGroup",
    /** Toggle section area */ sectionToggle: "sectionToggle",
    /** Placeholder area */ placeholder: "placeholder",
    /** Top drop zone */ topDropZone: "topDropZone",
    /** Bottom drop zone */ bottomDropZone: "bottomDropZone"
};
/**
 * HTML attribute for drag and drop role
 */ export const HtmlDnDRoleAttribute = "data-dnd-role";
/**
 * HTML attribute for data index
 */ export const HtmlDataIndexAttribute = "data-index";
/**
 * Literal class name for draggable task card
 */ export const DraggableTaskClassName = "planner-draggable-task-card";
/**
 * HTML attribute for data id
 */ export const HtmlDataIdAttribute = "data-id";
/**
 * HTML attribute for drop target
 */ export const HtmlDropTargetAttribute = "data-drop-target";
/**
 * HTML attribute values for drop targets
 */ export var HtmlDropTargetAttributeValues = /*#__PURE__*/ function(HtmlDropTargetAttributeValues) {
    /** Task pane drop target */ HtmlDropTargetAttributeValues["taskPane"] = "taskPane";
    return HtmlDropTargetAttributeValues;
}({});
/**
 * Class name for droppable task area. Use this to add custom styles to the drop target area.
 */ export const DroppableTargetClassName = "planner-droppable-target";
